import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'ui-formular-shell',
  imports: [MatProgressBarModule],
  templateUrl: './formular-shell.component.html',
  styleUrl: './formular-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormularShellComponent {
  stepProgress = input.required<number>();
}
